import type { PlatformMyResourcesArgs } from '@krp/platform-ui'
import { REFUNDS_CAPABILITY, RMK_RIGHT_ARGS, SOURCE_ARGS, TRACE_CAPABILITY, type AqsiSourcesArgs } from '@krp/resource-aqsi-ui'

/** Вид кабинета в реестре Platform: список «для кассы» и «для каталога» просит только его. */
export const AQSI_KIND = 'aqsi'

const minePlain = (args: AqsiSourcesArgs): PlatformMyResourcesArgs => ({ capability: args.capability, kind: AQSI_KIND })

/**
 * Аргументы общего списка «мои ресурсы» (`platformMyResources`) для окон AQSI: право цели из пакета, вид — `aqsi`.
 * Один клиент `me/resources` на весь клиент (RP-SRC1): своего у пакета AQSI нет. Объекты постоянные: один и тот же аргумент
 * у подписки и у `select`, иначе селектор читал бы чужой ключ кэша.
 */
export const AQSI_MINE = {
  rmk: minePlain(SOURCE_ARGS.rmk),
  catalog: minePlain(SOURCE_ARGS.catalog),
  sales: minePlain(SOURCE_ARGS.sales),
  salesRead: minePlain(SOURCE_ARGS.salesRead),
  price: minePlain(SOURCE_ARGS.price),
  trace: minePlain({ capability: TRACE_CAPABILITY }),
  takeover: minePlain(RMK_RIGHT_ARGS.takeover),
  closeAny: minePlain(RMK_RIGHT_ARGS.closeAny),
  journal: minePlain(RMK_RIGHT_ARGS.journal),
  /** RP-FB74: «Действия» → «Возврат» в РМК - только с правом `refunds.manage`. */
  refunds: minePlain({ capability: REFUNDS_CAPABILITY }),
} as const satisfies Readonly<Record<string, PlatformMyResourcesArgs>>
